import moment from 'moment';

const momentLib = moment;

export default class DateMoment {
  static defaultFormat = 'DD/MM/YYYY';

  static defaultTimeFormat = 'DD/MM/YYYY HH:mm:ss';

  static format(value, format) {
    let result;
    if (value) {
      if (typeof value === 'number') {
        result = momentLib.unix(value);
      } else {
        result = momentLib(String(value));
      }
      const dateFormat = typeof format === 'string' ? format : DateMoment.defaultFormat;
      result = result.format(dateFormat);
    }
    return result;
  }

  static formatTime = (value) => DateMoment.format(value, DateMoment.defaultTimeFormat);

  static from(endDate, startDate) {
    let result;
    if (endDate) {
      const start = moment(startDate);
      result = start.from(endDate);
    }
    return result;
  }

  static moment() {
    // eslint-disable-next-line prefer-rest-params
    return momentLib.call(moment, ...arguments);
  }
}
